import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react';
import Layout from '@/components/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import TimeOffPoliciesTab from '@/components/admin/people/TimeOffPoliciesTab';
import JobsTab from '@/components/admin/people/JobsTab';
import { CurrentUserProvider } from '@/hooks/useCurrentUser';

import { useI18n } from '@/hooks/useI18n';

function PeopleSettingsPage() {
    const [activeTab, setActiveTab] = useState('policies');
    const { t } = useI18n();

    return (
        <CurrentUserProvider>
        <Layout>
            <div className="space-y-6">
                {/* Header */}
                <div className="flex items-center justify-between">
                    <div>
                        <h1 className="text-3xl font-bold tracking-tight">
                            {t('peopleSettings.title', 'admin')}
                        </h1>
                        <p className="text-muted-foreground mt-1">
                            {t('peopleSettings.subtitle', 'admin')}
                        </p>
                    </div>
                </div>

                {/* Tabs */}
                <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
                    <TabsList>
                        <TabsTrigger value="policies">{t('peopleSettings.tabs.policies', 'admin')}</TabsTrigger>
                        <TabsTrigger value="jobs">{t('peopleSettings.tabs.jobs', 'admin')}</TabsTrigger>
                    </TabsList>

                    <TabsContent value="policies" className="space-y-4">
                        <TimeOffPoliciesTab />
                    </TabsContent>

                    <TabsContent value="jobs" className="space-y-4">
                        <JobsTab />
                    </TabsContent>
                </Tabs>
            </div>
            </Layout>
            </CurrentUserProvider>
    );
}

export const Route = createFileRoute('/admin/people/')({
    component: PeopleSettingsPage,
})
